import alloSquare from '@/assets/images/icon.png';
import logo from '@/assets/images/logo.png';
import logoSans from '@/assets/images/v3-icon-name-dark.png';
import { cn } from '@/lib/utils';
import { Link } from '@tanstack/react-router';

type AlloLogoProps = {
  variant?: 'dark' | 'sans-light';
  linkEnabled?: boolean;
  /** Tailwind classes merged onto the underlying `<img>`. Use for sizing
   *  overrides (e.g. `h-8` to render at 32px). Default size: 40px tall. */
  className?: string;
};

export const AlloLogo = ({ variant = 'dark', linkEnabled = false, className }: AlloLogoProps) => {
  const logoMap = {
    dark: logo,
    'sans-light': logoSans,
  };

  return (
    <Link
      to="/"
      preload={false}
      className="flex items-center justify-center gap-x-2"
      disabled={linkEnabled === false}
    >
      <img src={logoMap[variant]} alt="logo" className={cn('h-[40px] w-auto', className)} />
    </Link>
  );
};

export const AlloSquareLogo = () => {
  return <img src={alloSquare} alt="Allo logo" className="h-16 w-16" />;
};
